<div style="position: relative; height: 100%;">
  <div *ngIf="loading" class="loading-overlay">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
  
  <canvas baseChart
    [data]="pieChartData"
    [type]="pieChartType"
    [options]="pieChartOptions">
  </canvas>
</div>
